<template>
  <UPopover
    v-model:open="model"
    :content="{
      align: 'end',
      side: 'bottom',
      sideOffset: 8,
    }"
    :ui="{
      content: 'p-2 shadow-2xl min-w-52 lg:hidden',
    }"
  >
    <button
      id="mobile-menu-button"
      type="button"
      class="flex justify-center w-full p-1 text-sm font-medium ring ring-secondary rounded-md focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary"
    >
      <UIcon
        name="i-heroicons-bars-3-solid"
        class="text-primary size-7"
        aria-hidden="true"
      />

      <span class="sr-only">Menu</span>
    </button>

    <template #content>
      <UNavigationMenu
        color="primary"
        variant="link"
        orientation="vertical"
        highlight
        :items
        :ui="{
          link: 'hover:text-muted text-base font-medium data-[active]:bg-primary/10 hover:before:bg-primary/20 rounded-md p-2 cursor-pointer',
        }"
        class="min-w-60 w-full"
      />
      <slot />
    </template>
  </UPopover>
</template>
<script setup lang="ts" generic="T extends ArrayOrNested<NavigationMenuItem>">
import type { ArrayOrNested, NavigationMenuItem } from '@nuxt/ui'

defineProps<{
  items: T
}>()

const model = defineModel<boolean>('open')
</script>
